<template >
  <div class="detail">
    <Grid
      ref="item"
      :style="{ height: 'auto' }"
      :columns="columns"
      :data-items="dataItem.gpsData"
    ></Grid>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          hidden: false,
          field: "lastRawData",
          cell:this.rawData,
          title: "Last Raw Data",
          width:"auto",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "lastProcessedData",
          cell: this.processedData,
          title: "Last Processed Data",
          width:"auto",
          checked: true,
          defaultSelected: true,
        },
      ],
    };
  },
  props: {
    dataItem: Object,
  },
  
  methods: {
    rawData:function(h,tdElement,props){
     const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "null");
      }
      let mapObj = {
        "{" : " ",
        "}" : " ",
      }
      let res =  value.replace(/{|}/g , function(matched){
        return mapObj[matched]
      })
      return h("td", {}, res );
    },
    processedData: function (h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "null");
      }
      let mapObj = {
        "{" : " ",
        "}" : " ",
      }
      let res =  value.replace(/{|}/g , function(matched){
        return mapObj[matched]
      });
      return h("td", {}, res );
    },
  },
};
</script>
<style >
.k-grid th, .k-grid td {
    word-break: break-word;
}
</style>